
import React from 'react';
import { RelationshipChangeModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { RelationshipChangeModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new RelationshipChangeModalStore(rootStore, componentProps), 'relationshipChangeModalStore')
@observer
class RelationshipChangeModal extends React.Component {
    render() {
        return <RelationshipChangeModalTemplate {...this.props} />
    }
}

export default RelationshipChangeModal;
